import imsCountriesWithRegions from '../../common/ims-countries-with-regions.json';

const REGION_BY_COUNTRY_CODE = new Map(
  imsCountriesWithRegions.countries.map(({ countryCode, region }) => [countryCode, region]),
);

/**
 * True when the signed-in user's IMS profile `countryCode` maps to a region
 * included in `releaseRegions` (a comma-separated string, e.g. `VITE_RELEASE_REGIONS`,
 * or an array of region names such as `['APAC', 'EMEA']`).
 */
export async function isProfileInReleaseRegion(releaseRegions) {
  const profile = await window.adobeIMS.getProfile();
  if (profile?.countryCode === 'UD') return true;

  const region = REGION_BY_COUNTRY_CODE.get(profile?.countryCode);
  if (!region) return false;

  const regions = Array.isArray(releaseRegions) ? releaseRegions : String(releaseRegions).split(',');
  return regions.some((candidate) => candidate.trim().toUpperCase() === region.toUpperCase());
}
